import { RefObject, useState, useEffect } from "react";

export function useRefOffsetWidthResize(ref: RefObject<HTMLDivElement | null>) {
  const [inputWidth, setInputWidth] = useState<number>();

  useEffect(() => {
    // wait for ref before adding offset width to event listener
    if (!ref?.current) return undefined;

    const handleResize = () => {
      setInputWidth(ref?.current?.offsetWidth);
    };
    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, [ref]);

  return { inputWidth };
}
